import Breadcrumb from '@lmc/ui-kit/src/general/Breadcrumb/Breadcrumb'
import PropTypes from 'prop-types'
import React from 'react'
import { history } from '../../../../../../store'

export default function MedStockBreadcrumb(props) {
  const { medication } = props
  const { Item } = Breadcrumb

  return (
    <Breadcrumb>
      <Item>
        <button
          type="button"
          className="link-button"
          onClick={() => {
            history.push(
              `/residents/${medication.resident}/emar/${medication.id}/chart`
            )
          }}
        >
          {medication.name}
        </button>
      </Item>
      <Item>Stock</Item>
    </Breadcrumb>
  )
}

MedStockBreadcrumb.propTypes = {
  medication: PropTypes.object.isRequired
}
